import * as React from "react";
import {SyntheticEvent} from "react";
import {observer} from "mobx-react";
import {Link} from "react-router-dom";
import {action, runInAction} from "mobx";

import "./topic-switcher.scss";

import {Menu, Sidebar} from "semantic-ui-react";

import {AppState} from "../../../components/app/app-mobx";
import {MapState} from "../../map-state";
import {UiState} from "../../ui-state";

import {TopicConfiguration} from "../../../config/topic-configuration";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";

import { Icon } from "../icon/icon";
import {PathUtils} from "../../../utils/path-utils";
import {Popup} from "../popup/popup";


export interface TopicSwitcherProps {
    appStore: AppState;
    mapStore: MapState;
    uiStore: UiState;
    topics: TopicConfiguration[];
    mapviewerConfig: MapViewerConfiguration;
    small?: boolean;
}

@observer
export class TopicSwitcher extends React.Component<TopicSwitcherProps, any> {
    widgetKey = "topic-switcher";
    constructor(props: TopicSwitcherProps) {
        super(props);
        if (typeof this.props.small === "boolean" && this.props.small) {
            this.widgetKey += "-small";
        }

        this.handleMenuOpen = this.handleMenuOpen.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
    }

    @action
    setTopic(topic: TopicConfiguration) {
        runInAction(() => {
            const {appStore, mapviewerConfig, topics, uiStore} = this.props;
            // if a top-level topic was clicked, select the first child
            if (!topic.routes) {
                topic = mapviewerConfig.getFirstSubtopic(topic, topics);
            }
            // Falls sich das Subtopic ändert, Popup und Tools (z.B. Höhenprofil) schliessen
            if(topic.id !== appStore.subtopicId) {
                const popup = uiStore.widgets.get("popup") as Popup;
                if (popup) {
                    popup.close();
                }
                uiStore.setActiveTool("");
            }
            appStore.setSubtopic(topic);
            this.props.appStore.setRoutePath(PathUtils.joinPath(this.props.appStore.topic.routes[0], topic?.routes[0]));
        });
    }

    handleMenuOpen(event: SyntheticEvent, data: any) {
        event.preventDefault();
        const {topics} = this.props;
        this.handleToggle();
        const topic = topics?.find((t) => (t.id === data.name));
        if (!topic) {
            return;
        }
        this.setTopic(topic);
    }

    handleToggle(event?: SyntheticEvent) {
        const {uiStore} = this.props;
        if (uiStore.topicswitcherVisible) {
            uiStore.setTopicswitcherVisible(false);
        } else {
            uiStore.setTopicswitcherVisible(true);
        }
        if(event) {
            event.preventDefault();
        }
    }

    componentDidMount(): void {
        const {uiStore} = this.props;
        if (uiStore.widgets.has(this.widgetKey)) {
            return;
        }
        uiStore.addWidget(this.widgetKey, this);
    }

    componentWillUnmount(): void {
        const {uiStore} = this.props;
        uiStore.removeWidget(this.widgetKey);
    }

    render() {
        const {subtopic, topic} = this.props.appStore;
        const {topicswitcherVisible} = this.props.uiStore;
        const {small, topics} = this.props;

        if (!subtopic) {
            return null;
        }
        const hasSubtopics = topics.some((t) => t.parentId);
        const items = topics.filter((t) => !t.parentId).flatMap((topicConfig) => {
            const parentItems: JSX.Element[] = [];
            parentItems.push(
                <Menu.Item
                    as={Link} to={
                        PathUtils.joinPath(topic.routes[0],(topicConfig.routes? topicConfig.routes[0]: topicConfig.id))}
                    onClick={this.handleMenuOpen}
                    key={topicConfig.id}
                    name={topicConfig.id}
                    active={topicConfig.id === subtopic.id}
                    position={small ? "left" : "right"}
                    className={hasSubtopics? "level-1": "level-2"}>
                    {small && topicConfig.icon ? <Icon name={topicConfig.icon}/> : null}
                    {topicConfig.label? topicConfig.label: topicConfig.name}
                    {!small && topicConfig.icon ? <Icon name={topicConfig.icon}/> : null}
                </Menu.Item>
            );
            if (hasSubtopics) {
                this.props.topics.filter((subT) => topicConfig.id === subT.parentId).forEach((subT) => {
                    parentItems.push(<Menu.Item
                        as={Link} to={PathUtils.joinPath(topic.routes[0],(subT.routes? subT.routes[0]: subT.id))}
                        onClick={this.handleMenuOpen}
                        key={subT.id}
                        name={subT.id}
                        active={subT.id === subtopic.id}
                        position={small ? "left" : "right"}
                        className={"level-2"}>
                        {small && subT.icon ? <Icon name={subT.icon}/> : null}
                        {subT.label ? subT.label : subT.name}
                        {!small && subT.icon ? <Icon name={subT.icon}/> : null}
                    </Menu.Item>);
                });
            }
            return parentItems;
        });
        items.unshift(<div className={"item geo-topic-switcher-header"} key={"topic-switcher-header"}>
            {!small? <Icon name={"signpost"} className={"icon--topic-switcher"} />: null}
            Thema in dieser Karte wählen
            {!small?
                <div onClick={this.handleToggle} className={"geo-close"}><Icon name="navigate_cross" /></div>: null}
        </div>);
        if (small) {
            return (
                <Menu
                    className="geo-topic-switcher-menu menu-small"
                    vertical
                    visible={topicswitcherVisible.toString()}>
                    {items}
                </Menu>
            );
        } else {
            return <Sidebar
                className="geo-topic-switcher-menu"
                as={Menu}
                animation="overlay"
                direction={"top"}
                vertical
                visible={topicswitcherVisible}>
                {items}
            </Sidebar>;
        }
    }
}
